import { Component, Input, OnInit } from '@angular/core';
import {
    Aangifte,
    AangifteBerekening, AangifteRapport, BokkzAlgDataService,
    Box1Berekening, IncomeTaxEntity,
    OpbouwBox1, OpbouwLijfrente, OpbouwROW, OpbouwZvw, SpecificatieLijfrente,
    SpecificatieROW, SpecificatieZvw, Voorheffingen
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject } from 'rxjs';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { number } from 'mathjs';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule, DecimalPipe } from '@angular/common';


@Component({
    selector: 'snelstart-venture-fiscaal-feature-zorgverzekeringswet',
    templateUrl: './zorgverzekeringswet.component.html',
    imports: [
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        DecimalPipe,
        CommonModule
    ],
    styleUrls: ['./zorgverzekeringswet.component.scss']
})
export class ZorgverzekeringswetComponent implements OnInit {
    public aangifte = {} as Aangifte;
    @Input() public id!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;
    private partnerAangifte = {} as Aangifte;

    berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    berekening = {} as AangifteBerekening;
    aangifteBerekening = {} as AangifteBerekening;
    partnerBerekening = {} as AangifteBerekening;

    rapportFormGroup = this.fb.group<AangifteRapport>({});
    rapport = {} as AangifteRapport;
    partnerRapport = {} as AangifteRapport;
    aangifteRapport = {} as AangifteRapport;

    public voorlZvw = this.fb.group<Voorheffingen>({});

    public tussentellingenFg = {} as FormGroup;

    public hasGeenBijdrageInkomen = false;
    public year = 2024;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox1>(({
                    winstUitOnderneming: null as unknown as number,
                    belastbaarloon: null as unknown as number,
                    resultaatUitOverigeWerkzaamheden: null as unknown as number,
                    periodiekeUitkeringen: null as unknown as number,
                    inkomstenUitEigenWoning: null as unknown as number,
                    saldoEigenWoning: null as unknown as number,
                    negatieveUitgavenVoorInkomensvoorzieningen: null as unknown as number,
                    negatievePersoonsgebondenAftrek: null as unknown as number,
                    overigeInkomsten: null as unknown as number,
                    aftrekWegensGeenOfGeringeEigenWoningSchuld: null as unknown as number,
                    uitgavenVoorInkomensvoorzieningen: null as unknown as number
                } as OpbouwBox1))
            } as Box1Berekening)),
            verschuldigdeZVW: null as unknown as number,
            totaalBijdrageInkomen: null as unknown as number
        } as AangifteBerekening));
        this.rapportFormGroup = this.fb.group<AangifteRapport>(({
            specificatieZvw: this.fb.group<SpecificatieZvw>(({
                opbouw: this.fb.group<OpbouwZvw>(({
                    loonHogerDanMaximumBijdrageInkomen: null as unknown as boolean,
                    loonWaaroverIsGeheven: null as unknown as number,
                    loonAlsOnderdeelVanWinst: null as unknown as number,
                    loonBuitenlandVoorZvw: null as unknown as number,
                    vrijgesteldLoonVoorZvw: null as unknown as number
                }))
            } as OpbouwZvw)),
            specificatieLijfrente: this.fb.group<SpecificatieLijfrente>(({
                opbouw: this.fb.group<OpbouwLijfrente>(({
                    premieOmzettingForBijStaking: null as unknown as number,
                    premieAfstortingFor: null as unknown as number
                }))
            } as OpbouwLijfrente)),
            specificatieRow: this.fb.group<SpecificatieROW>(({
                opbouw: this.fb.group<OpbouwROW>(({
                    inkomstenUitOVerigeWerkzaamheden: null as unknown as number,
                    kostenTerZakeVanOverigeWerkzaamheden: null as unknown as number,
                    inkomstenUitTBS: null as unknown as number,
                    tbsVrijstelling: null as unknown as number,
                    openingsbalansEV: null as unknown as number,
                    slotbalansEV: null as unknown as number
                }))
            } as OpbouwLijfrente))
        } as AangifteRapport));
        this.tussentellingenFg = this.fb.group({
            totaalBijdrageInkomen: null as unknown as number | undefined,
            totaalBijdrageInkomenNaMaxEnLoon: null as unknown as number | undefined,
            percentageZwv: null as unknown as number,
            maxPremieLoon: null as unknown as number,
            voorlopigeAanslagZvw: null as unknown as number,
            verschuldigdePremie: null as unknown as number
        });
    }

    public ngOnInit(): void {
        this.dataService.aangifteBerekening.subscribe((berekening) => {
            this.aangifteBerekening = berekening;
            if (berekening.partnerBerekening) {
                this.partnerBerekening = berekening.partnerBerekening;
            }
        });
        this.dataService.aangifteRapport.subscribe((aangifteRapport) => {
            this.aangifteRapport = aangifteRapport;
        });
        this.dataService.partnerAangifteRapport.subscribe((partnerAangifteRapport) => {
            this.partnerRapport = partnerAangifteRapport;
        });
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.partner.subscribe((partner) => {
                    this.berekeningFormGroup.reset();
                    this.tussentellingenFg.reset();
                    this.rapportFormGroup.reset();
                    this.partnerBoolean = partner;
                    if (partner) {
                        this.berekeningFormGroup.reset();
                        this.tussentellingenFg.reset();
                        this.rapportFormGroup.reset();
                        this.berekening = this.partnerBerekening;
                        this.berekeningFormGroup.patchValue(this.berekening);
                        this.rapport = this.partnerRapport;
                        this.rapportFormGroup.patchValue(this.rapport);
                        this.corrigeerWinstVoorLoon();
                        this.calculateZvw();
                        this.infoGeenBijdrageInkomen();
                    } else {
                        this.berekeningFormGroup.reset();
                        this.tussentellingenFg.reset();
                        this.rapportFormGroup.reset();
                        this.berekening = this.aangifteBerekening;
                        this.berekeningFormGroup.patchValue(this.berekening);
                        this.rapport = this.aangifteRapport;
                        this.rapportFormGroup.patchValue(this.rapport);
                        this.corrigeerWinstVoorLoon();
                        this.calculateZvw();
                        this.infoGeenBijdrageInkomen();
                    }
                });
                if (incomeTaxEntity.year !== undefined) {
                    this.year = incomeTaxEntity.year;
                }
            }

        });
        this.disableFormGroup(this.berekeningFormGroup);
        this.disableFormGroup(this.tussentellingenFg);
        this.disableFormGroup(this.rapportFormGroup);
        this.disableFormGroup(this.voorlZvw);
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    calculateZvw(): void {
        if (this.aangifte.aangifteJaar === 2024) {
            this.tussentellingenFg.get('percentageZwv')?.patchValue(5.32);
            this.tussentellingenFg.get('maxPremieLoon')?.patchValue(71628);
        } else if (this.aangifte.aangifteJaar === 2025) {
            this.tussentellingenFg.get('percentageZwv')?.patchValue(5.26);
            this.tussentellingenFg.get('maxPremieLoon')?.patchValue(75864);
        } else if (this.aangifte.aangifteJaar === 2026) {
            this.tussentellingenFg.get('percentageZwv')?.patchValue(4.85);
            this.tussentellingenFg.get('maxPremieLoon')?.patchValue(79409);
        }

        const winstUitOnderneming = this.berekening.box1?.opbouwInkomen?.winstUitOnderneming ?? 0;
        const loonInWinst = this.incomeTaxEntity.aangifte?.voorheffingen?.loonAlsOnderdeelVanWinst ?? 0;
        const periodiekeUitkeringen = this.berekening.box1?.opbouwInkomen?.periodiekeUitkeringen ?? 0;
        const opbrengstenRow = this.rapport.specificatieROW?.opbouw?.inkomstenUitOVerigeWerkzaamheden ?? 0;
        const kostenRow = this.rapport.specificatieROW?.opbouw?.kostenTerZakeVanOverigeWerkzaamheden ?? 0;
        const resultaatUitOverigeWerkzaamheden = opbrengstenRow - kostenRow;
        const loonBuitenland = this.rapport.specificatieZvw?.opbouw?.loonBuitenlandVoorZvw ?? 0;
        const vrijgesteldLoon = this.rapport.specificatieZvw?.opbouw?.vrijgesteldLoonVoorZvw ?? 0;
        const loonWaaroverIsGeheven = this.rapport.specificatieZvw?.opbouw?.loonWaaroverIsGeheven ?? 0;
        const premiesLijfrenteFor = this.rapport.specificatieLijfrente?.opbouw?.premieAfstortingFor ?? 0;
        const premiesLijfrenteForStaking = this.rapport.specificatieLijfrente?.opbouw?.premieOmzettingForBijStaking ?? 0;

        const totaalBijdrageInkomen = winstUitOnderneming - loonInWinst + periodiekeUitkeringen + resultaatUitOverigeWerkzaamheden + loonBuitenland + vrijgesteldLoon + loonWaaroverIsGeheven - premiesLijfrenteFor - premiesLijfrenteForStaking;
        this.tussentellingenFg.get('totaalBijdrageInkomen')?.patchValue(totaalBijdrageInkomen);

        const maximumInkomen = this.tussentellingenFg.get('maxPremieLoon')?.value;
        const loonZvw = this.rapportFormGroup.get(['specificatieZvw', 'opbouw', 'loonWaaroverIsGeheven'])?.value;
        let totaalBijdrageInkomenNaMaxEnLoon;
        if (totaalBijdrageInkomen > maximumInkomen) {
            totaalBijdrageInkomenNaMaxEnLoon = maximumInkomen - loonZvw;
        } else {
            totaalBijdrageInkomenNaMaxEnLoon = totaalBijdrageInkomen - loonZvw;
        }
        this.tussentellingenFg.get('totaalBijdrageInkomenNaMaxEnLoon')?.patchValue(totaalBijdrageInkomenNaMaxEnLoon);

        let voorlZvw = 0;
        let teBetalenPremie = 0;
        if (this.partnerBoolean) {
            voorlZvw = this.aangifte.partnerAangifte?.voorheffingen?.voorlopigeAanslagZvw || 0;
            teBetalenPremie = this.berekening.verschuldigdeZVW || 0;
            this.tussentellingenFg.get('voorlopigeAanslagZvw')?.patchValue(voorlZvw);
            const verschuldigdePremie = teBetalenPremie + voorlZvw;
            this.tussentellingenFg.get('verschuldigdePremie')?.patchValue(verschuldigdePremie);
            console.log('zvw voorlZvw', voorlZvw);
            console.log('zvw teBetalenPremie', teBetalenPremie);
            console.log('zvw verschuldigdePremie', verschuldigdePremie);
        }
        if (!this.partnerBoolean) {
            voorlZvw = this.aangifte.voorheffingen?.voorlopigeAanslagZvw || 0;
            teBetalenPremie = this.berekening.verschuldigdeZVW || 0;
            this.tussentellingenFg.get('voorlopigeAanslagZvw')?.patchValue(voorlZvw);
            const verschuldigdePremie = teBetalenPremie + voorlZvw;
            this.tussentellingenFg.get('verschuldigdePremie')?.patchValue(verschuldigdePremie);
            console.log('zvwA voorlZvw', voorlZvw);
            console.log('zvwA teBetalenPremie', teBetalenPremie);
            console.log('zvwA verschuldigdePremie', verschuldigdePremie);
        }
    }


    private infoGeenBijdrageInkomen() {
        if (this.tussentellingenFg.get(['totaalBijdrageInkomen'])?.value === null || this.tussentellingenFg.get(['totaalBijdrageInkomen'])?.value === 0) {
            this.hasGeenBijdrageInkomen = true;
        } else {
            this.hasGeenBijdrageInkomen = false;
        }
    }

    protected readonly number = number;

    private corrigeerWinstVoorLoon(): void {
        const loonAlsOnderdeelVanWinst = this.rapportFormGroup
            .get(['specificatieZvw', 'opbouw', 'loonAlsOnderdeelVanWinst'])?.value ?? 0;

        if (loonAlsOnderdeelVanWinst > 0) {
            const winstControl = this.berekeningFormGroup
                .get(['box1', 'opbouwInkomen', 'winstUitOnderneming']);

            const huidigeWaarde = winstControl?.value ?? 0;
            winstControl?.setValue(huidigeWaarde - loonAlsOnderdeelVanWinst, { emitEvent: false });
        }
    }
}


